import { createStyles, withStyles, type WithStyles } from "@material-ui/core";
import { CustomTable } from "features/shared/components";
import React from "react";
import type { EnrichedHerdRecord } from "shared/types";
import { useMovementListTable } from "../hooks/useMovementsListTable";
import { MovementListTableColumn } from "../utils/movements.utils";

type MovementListTableProps = {
  movements: EnrichedHerdRecord[];
  isFormPanelOpen: boolean;
  onConfirmRequest: (row: EnrichedHerdRecord) => void;
  onEditClick: (row: EnrichedHerdRecord) => void;
  onDeleteRequest: (row: EnrichedHerdRecord) => void;
} & WithStyles<typeof styles>;

function MovementListTable({
  isFormPanelOpen,
  movements,
  onConfirmRequest,
  onDeleteRequest,
  onEditClick,
}: MovementListTableProps) {
  const { columns } = useMovementListTable({
    isFormPanelOpen,
    onConfirmRequest,
    onDeleteRequest,
    onEditClick,
  });

  return (
    <CustomTable
      columns={columns}
      getRowId={(row) => row.id.toString()}
      id="movement-list-table"
      initialOrder={{
        orderBy: MovementListTableColumn.OperationDate,
        order: "desc",
      }}
      rows={movements}
    />
  );
}

const styles = () => createStyles({});

export default withStyles(styles)(MovementListTable);
